import { render, staticRenderFns } from "./BFormPlan.vue?vue&type=template&id=4fad3d4c&scoped=true&"
import script from "./BFormPlan.vue?vue&type=script&lang=js&"
export * from "./BFormPlan.vue?vue&type=script&lang=js&"
import style0 from "./BFormPlan.vue?vue&type=style&index=0&id=4fad3d4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fad3d4c",
  null
  
)

export default component.exports